import classNames from 'classnames/bind';
import styles from './TipCards.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPenToSquare } from '@fortawesome/free-regular-svg-icons';
import { useContext } from 'react';
import { LoginContext } from '~/component/Context/LoginProvider';
import { ModalOverLayContext } from '~/component/Context/ModalOverLayProvider';
import EditTip from '~/component/EditTip';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { postData } from '~/helper/apiService';
import ConfirmModal from '~/component/ConfirmModal';
import { NavLink } from 'react-router-dom';
import routes from '~/configs';
import CodeBlock from '~/component/CodeBlock';
import Controller from '~/component/Controller';
import { ToastContext } from '~/component/Context/ToastProvider';
const cx = classNames.bind(styles);

function TipItem({ tip, type, loadTips }) {
  const { loginStatus } = useContext(LoginContext);
  const { setModalComponentContent } = useContext(ModalOverLayContext);

  const { addToast } = useContext(ToastContext);
  const handleRemoveProject = async (id) => {
    const formData = new FormData();
    formData.append('id', id);
    const res = await postData('/tips/delete', formData);
    if (res.status === 'success') {
      loadTips();
      setModalComponentContent(null);
    }
    addToast(res);
  };

  const handleClickDelete = (id) => {
    setModalComponentContent(
      <ConfirmModal
        title="Xác nhận xóa tip"
        handleConfirm={() => handleRemoveProject(id)}
        handleCancel={()=>setModalComponentContent(null)}
      />,
    );
  };

  const handleClickEdit = () => {
    setModalComponentContent(<EditTip id={tip.id} />);
  };

  return (
    <div className={cx('article-card')}>
      {loginStatus && (
        <Controller className={cx('controller')} handleEdit={handleClickEdit} handleDelete={()=>handleClickDelete(tip.id)} />
      )}
      <NavLink className={cx('content')} to={routes.tipDetail + '/' + tip.id}>
        <div className={cx('head')}>
          <p className={cx('date')}>Article on {tip.date_create}</p>
          <h3 className={cx('title')}>{tip.title}</h3>
        </div>
        <CodeBlock language="javascript" code={tip.introduce} />
        <div className={cx('foot')}>
          <p className={cx('info-type')}>{type}</p>
          <p className={cx('info-name')}>Create by Quyen</p>
        </div>
      </NavLink>
    </div>
  );
}

export default TipItem;
